/**
 * The core middleware is responsible for handling external API requests
 */

import axios from "axios";
import alertify from "alertifyjs";
import { API_REQUEST, apiError, apiSuccess, loginSuccess, passwordResetRequired, FETCH_BLOGS, blogsFetched, FETCH_BLOG, blogFetched, FETCH_CATEGORIES, categoriesFetched, FETCH_LANGUAGES, languagesFetched, FETCH_ROLES, rolesFetched, API_REQUEST_SAVE_BLOG, UPDATE_BLOG, usersFetched, FETCH_USERS, DownloadProgress, UploadProgress, blogSaved, blogUpdated, TRANSLATE_TEXT, translated, staticsFetched, FETCH_STATICS, UPDATE_STATICS, STATICS_UPDATED, FETCH_DEVICES, devicesFetched, UPDATE_DEVICE, deviceUpdated, fetchDevices, FETCH_ATTENDANCE, attendanceFetched, REQUEST_REGISTER, registerRequested, RECORD_ATTENDANCE, customMiddleResponse } from "../actions/api";
import { logout } from "../actions/auth";
import { setLoader } from "../actions/ui";

export const apiMiddleware = ({ dispatch }) => next => action => {
  next(action);
  axios.defaults.onDownloadProgress = (progressEvent) => {
    var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
    dispatch(DownloadProgress(percentCompleted));
  }
  axios.defaults.onUploadProgress = (progressEvent) => {
    var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
    dispatch(UploadProgress(percentCompleted));
  }
  axios.interceptors.response.use(
    response => response,
    error => {
      console.log(error)
      const { status } = error.response;
      if (status === 401) {
        dispatch(logout());
      }
      return Promise.reject(error);
    }
  );

  if (action.type === API_REQUEST) {
    dispatch(setLoader(true));
    // var further = apiSuccess;
    // if (action.requestFor === "LOGIN") further = loginResponse;
    const { url, method, data, headers, params } = action.meta;
    const payload = {
      method,
      url,
      data,
      headers,
      params,
      mode: 'cors'
    };
    axios(payload)
      .then(({ data }) => {
        const { result, status, message } = data;
        if (status === 400) {
          console.log("errr");
          console.log(result);
          alertify.error(message);
          dispatch(apiError({}))
        }
        if (action.CUSTOM_MIDDLE) {
          dispatch(customMiddleResponse({ requestedBy:action.requestedBy, payload: data.result }));
        }
        else if (action.requestFor === "LOGIN") {
          console.log(status)
          if (status === 200) {
            alertify.success("Logged in!");
            dispatch(loginSuccess({ response: result }))
          }
          else if (status === 201) {
            alertify.message("Need to reset password!");
            dispatch(passwordResetRequired({ response: result }))
          }
          else {
            alertify.error(result);
          }
        }
        else if (action.requestFor === "PASSWORD_RESET") {
          const result = data.result;
          if (result.status === 100) dispatch(loginSuccess({ response: result }))
          else if (result.status === 200) dispatch(passwordResetRequired({ response: result }))
        }
        else if (action.requestFor === FETCH_BLOGS) {
          const result = data.result;
          if (data.status === 200) dispatch(blogsFetched({ response: result.blogs }))
        }
        else if (action.requestFor === FETCH_BLOG) {
          const result = data.result;
          if (data.status === 200) dispatch(blogFetched({ response: result.blogs }))
        }
        else if (action.requestFor === FETCH_USERS) {
          const result = data.result;
          if (data.status === 200) dispatch(usersFetched({ response: result }))
        }
        else if (action.requestFor === FETCH_CATEGORIES) {
          const result = data.result;
          if (data.status === 200) dispatch(categoriesFetched({ response: result }))
        }
        else if (action.requestFor === FETCH_LANGUAGES) {
          const result = data.result;
          if (data.status === 200) dispatch(languagesFetched({ response: result }))
        }
        else if (action.requestFor === FETCH_ROLES) {
          const result = data.result;
          if (data.status === 200) dispatch(rolesFetched({ response: result }))
        }
        else if (action.requestFor === FETCH_DEVICES) {
          const result = data.result;
          console.log(data);
          if (data.status === 200) dispatch(devicesFetched({ response: result }))
        }
        else if (action.requestFor === FETCH_ATTENDANCE) {
          const result = data.result;
          console.log(data);
          if (data.status === 200) dispatch(attendanceFetched({ response: result }))
        }
        else if (action.requestFor === REQUEST_REGISTER) {
          const result = data.result;
          console.log(data);
          if (data.status === 200) dispatch(registerRequested({ response: result }))
        }
        else if (action.requestFor === UPDATE_DEVICE) {
          if (message) alertify.success(message);
          dispatch(deviceUpdated());
          dispatch(fetchDevices());
        }
        else if (action.requestFor === RECORD_ATTENDANCE) {
          if (data.status === 200) {
            if (message)
              alertify.success(message);
            dispatch(setLoader(false));
          }
        }
        else if (action.requestFor === UPDATE_BLOG) {
          if (message) alertify.success(message);
          dispatch(blogUpdated());
          // dispatch(fetchBlogs());
        }
        else if (action.requestFor === TRANSLATE_TEXT) {
          if (message) alertify.success(message);
          dispatch(translated({ response: result }));
          // dispatch(fetchBlogs());
        }
        else if (action.requestFor === FETCH_STATICS) {
          if (message) alertify.success(message);
          dispatch(staticsFetched({ response: result }));
        }
        else if (action.requestFor === UPDATE_STATICS) {
          if (message) alertify.success(message);
          dispatch({ type: STATICS_UPDATED });
        }
        else {
          if (message) alertify.success(message);
          dispatch(apiSuccess({ response: data, requestFor: action.requestFor }))
        }
        // dispatch(further({ response: data }))
      })
      .catch(error => {
        console.log(error);
        dispatch(apiError({ error: error.response }));
      });
  }
  else if (action.type === API_REQUEST_SAVE_BLOG) {
    dispatch(setLoader(true));

    const { saveBlogUrl, data: Pdata, headers } = action.meta;
    console.log(Pdata);

    // process.then(({ data }) => {
    // way to upload file to s3 using presigned upload url.
    // const uploadFilePayload = {
    //   url: result,
    //   method: "PUT",
    //   data: Pdata.featuredMediaFile,
    //   // onUploadProgress: (ev) => console.log(ev),

    // };
    const uploadDataPayload = {
      url: saveBlogUrl,
      method: "POST",
      // data: {
      //   title: Pdata.title,
      //   description: Pdata.description,
      //   featured_media: Pdata.featuredMediaUrl,
      //   featured_media_type: Pdata.featuredMediaType,
      //   featured_image_url: Pdata.featuredImageUrl,
      //   category_id: Pdata.category_id,
      //   extra_media: Pdata.extra_media,
      //   blogBodyRaw: Pdata.blogBodyRaw
      // },
      data: Pdata,
      headers
    }
    const uploadData = axios(uploadDataPayload)

    uploadData.then(({ response }) => {
      alertify.success("Blog saved!")
      dispatch(blogSaved());
      // dispatch(fetchBlogs());
    }).catch(error => {
      console.log(error);
      alertify.error("error saving blog")
      dispatch(apiError({ error: error.response }))
    })
    // })
  }
};